import React, { useState } from "react";
import { Box, Button, Chip, Typography, CircularProgress } from "@mui/material";
import "./GenerateTags.css";

const MAX_SELECTION = 2;

const GenerateTags = ({
  technology,
  skill,
  body,
  onTagsChange,
  onGenerateTags,
  loading
}) => {
  const [generatedTags, setGeneratedTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const isEnabled = technology && skill && body.trim().length > 0;
  const handleGenerate = async () => {
    if (!isEnabled) return;

    const tags = await onGenerateTags();

    if (tags && tags.length) {
      setGeneratedTags(tags.slice(0, 4));
      setSelectedTags([]);
      onTagsChange([]);
    }
  };

  const handleSelect = (tag) => {
    let updated = [];

    if (selectedTags.includes(tag)) {
      updated = selectedTags.filter((t) => t !== tag);
    } else {
      if (selectedTags.length >= MAX_SELECTION) return;
      updated = [...selectedTags, tag];
    }

    setSelectedTags(updated);
    onTagsChange(updated);
  };

  return (
    <Box>
      <Typography className="tags_typography">
        Tags <span style={{ color: "red" }}>*</span>
      </Typography>
      <Box className="Generate_tags_section">
        <Typography variant="caption" className="generate_tags_typo">
          Click on the button to generate appropriate tags or topics for the
          question and choose any 2 most relevant options.
        </Typography>

        {/* Generate Button */}
        <Box>
          <Button className="generate_ai_button"
            variant="contained"
            onClick={handleGenerate}
            disabled={!isEnabled || loading}
            sx={{
              backgroundColor: isEnabled ? "#A100FF" : "#CFCFCF",
              color: isEnabled ? "#fff" : "#555555",
              textTransform: "none",
              minWidth: "150px",
              "&:hover": {
                backgroundColor: isEnabled ? "#5e00a0" : "#CFCFCF",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "#CFCFCF" }} />
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  cursor: isEnabled ? "pointer" : "not-allowed",
                  opacity: isEnabled ? 1 : 0.7,
                }}
              >
                <img
                  src={
                    isEnabled
                      ? process.env.PUBLIC_URL +"/images/Home/enable_Vector.png"
                      : process.env.PUBLIC_URL +"/images/Home/disable_vector.png"
                  }
                  alt="GenAI Icon"
                  style={{ width: "18px", height: "18px" }}
                />

                <Typography
                  sx={{
                    color: isEnabled ? "#ffffff" : "#555555",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  Generate Tags
                </Typography>
              </Box>
            )}
          </Button>
        </Box>
      </Box>

      {/* Disclaimer */}
      <Box className="generate_tags_disclaimer_section">
        <img src={process.env.PUBLIC_URL + "/images/Home/disclaimer_icon.png"}
          alt="disclaimer"
          style={{ width: "14px", height: "14px" }} />
      <Typography variant="caption" display="block" sx={{ color: "#808080", lineHeight:"normal"}}>
        Disclaimer: AI generated tags must be reviewed by the user before selecting them.
      </Typography>
      </Box>
      {/* Tags */}
      {generatedTags.length > 0 && (
        <Box mt={2}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography mt={1} className="tags_typography">
              Select any 2 tags <span style={{ color: "red" }}>*</span>
            </Typography>

            <Typography fontSize="12px" color="#818180">
              {selectedTags.length} / {MAX_SELECTION} Selected
            </Typography>
          </Box>

          <Box gap={1} flexWrap="wrap" className="GenerateTags_chips">
            {generatedTags.map((tag) => {
              const isSelected = selectedTags.includes(tag);

              return (
                <Box
                  key={tag}
                  onClick={() => handleSelect(tag)}
                  sx={{
                    position: "relative",
                    padding: "8px 14px",
                    border: isSelected ? "1px solid #7500C0" : "1px solid #CFCFCF",
                    color: isSelected ? "#7500C0" : "#555555",
                    cursor: "pointer",
                    backgroundColor: isSelected ? "#E6DCFF" : "#F1F1EF",
                    fontWeight: isSelected ? "600" : "500",
                    minWidth: "120px",
                    textAlign: "left",
                    fontSize: "13px",
                    transition: "all 0.2s ease",
                    textTransform: "capitalize"
                  }}
                >
                  {tag}

                  {/* Tick Icon */}
                  {isSelected && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "6px",
                        right: "4px",
                        width: "20px",
                        height: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={process.env.PUBLIC_URL + "/images/Home/Done.png"}
                        alt="selected"
                        style={{ width: "15px", height: "15px" }}
                      />
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default GenerateTags;